var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecordCenter = function SvgRecordCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    className: "record-bg"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.24,
    cx: 80,
    cy: 80,
    r: 55.19
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 5
  })));
};
export default SvgRecordCenter;